import React from 'react';
import { Switch } from 'react-router-dom';
import DashboardLayout from '../../layouts/DashoardLayout';
import PrivateRoute from '../../components/shared/PrivateRoute';
import DriverNotifications from './DriverNotifications';

const Notifications = () => {
  return (
    <DashboardLayout flush title="Notifications">
      <Switch>
        <PrivateRoute path="/notifications/drivers" component={DriverNotifications} />
        <PrivateRoute component={DriverNotifications} />
      </Switch>
    </DashboardLayout>
  );
};

export default Notifications;
